import React from 'react';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import CreditMemoRequestItem from '../../../Domain/CreditMemo/CreditMemoRequestItem';
import CreditMemoRequestService from '../../../Services/CreditMemo/CreditMemoRequestService';

export default class CreditMemoStatusChangeWindowDescription {
  static titleForEdit = 'Credit Memo Request Status Change';
  static itemType = CreditMemoRequestItem;
  static serviceFunction = (edited) => CreditMemoRequestService.AdvanceCreditMemoRequestWorkflow(edited);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'CreditMemoRequestWorkflowAction',
          label: 'CreditMemoRequestWorkflowAction',
          className: 'col-12',
          type: InputTypesEnum.CreditMemoRequestStatusChange,
          EntityId: 'CreditMemoRequestId',
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'Comment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: (e, item) =>
            [2, 3, 6, 8, 9, 12, 13].includes(parseInt(item?.CreditMemoRequestWorkflowAction))
              ? ValidityHelper.forRequiredTextField(e)
              : ValidityHelper.AlwaysFlawless(e),
        },
      ],
    },
  ];
}
